import Divider from "components/Divider";
import { ROLE_CANDIDATE, ROLE_CANDIDATE_EPG } from "utils/ConstantsAndNum";
import { UserType } from "state/User/types";
import { Icon } from "@utp/react-components-prod";

interface ISideBarProps {
  isActiveMenu: boolean;
  setIsActiveMenu: React.Dispatch<React.SetStateAction<boolean>>;
  handleLogoutClick: () => void;
  user: UserType | null;
}

const SideBar = ({
  user,
  isActiveMenu,
  setIsActiveMenu,
  handleLogoutClick,
}: ISideBarProps) => {

  const getRoleDisplayName = (role: string): string => {
    const candidateRoles = [ROLE_CANDIDATE.toUpperCase(), ROLE_CANDIDATE_EPG.toUpperCase()];
    return candidateRoles.includes(role) ? "Postulante" : role;
  };

  return (
    <div
      className={`absolute left-0 top-0 h-screen w-[300px] z-20 transition-transform duration-500 ease-in-out ${
        isActiveMenu ? "transform translate-x-0" : "transform translate-x-full-"
      } bg-grey-90`}
    >
      <div className="w-full flex justify-end px-5 py-6 cursor-pointer">
        <Icon
          size={24}
          iconName="arrow-left"
          className="mr-2 text-white"
          data-testid="btn-menu-close"
          onClick={() => setIsActiveMenu(!isActiveMenu)}
        />
      </div>
      {user && (
        <div className="flex px-16 py-14">
          <div className="mr-5">
            <div className="w-14 h-14 bg-grey-10 rounded-full flex justify-center items-center">
              <span className="font-bold text-subheading-01 uppercase">
                {user?.firstName?.[0]}
              </span>
            </div>
          </div>
          <div className="mr-5">
            <div className="text-white">
              <span>Hola,</span>
              <strong className="font-bold">{user?.firstName}</strong>
            </div>
            <div className="text-start text-white">
              <span className="text-small-02 font-normal">
                {getRoleDisplayName(user?.role)}
              </span>
            </div>
          </div>
        </div>
      )}
      <Divider />
      <div className="mt-10">
        <div className="bg-white h-56 text-color-02 font-bold flex items-center px-16 cursor-pointer">
          <p className="flex items-center">
            <Icon iconName="file-text" className="mr-2" size={20} /> Examen
          </p>
        </div>
      </div>
      <button
        className="text-white absolute bottom-0 h-56 w-full px-16 flex items-center cursor-pointer"
        tabIndex={isActiveMenu ? 0 : -1}
        aria-hidden={!isActiveMenu}
        onClick={handleLogoutClick}
        data-testid="btn-logout"
      >
        <p className="flex items-center">
          <Icon iconName="log-out" className="mr-2 text-white" size={20} /> Cerrar
          sesión
        </p>
      </button>
    </div>
  );
};

export default SideBar;
